import {Component, input, output} from '@angular/core';
import {ElciaButton} from '../../../../../../../../components/buttons/button/button';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';
import {AccountingAccountSummary} from '../../../../../../../../../api';

@Component({
  selector: 'elcia-accounting-account-grid',
  imports: [TableModule, TranslatePipe, ElciaButton],
  templateUrl: './accounting-account-grid.html',
})
export class AccountingAccountGrid {
  accountingAccounts = input.required<AccountingAccountSummary[]>();
  accountingAccountSelected = output<AccountingAccountSummary>();
  onDelete = output<AccountingAccountSummary>();

  onRowSelect(accountingCode: AccountingAccountSummary): void {
    this.accountingAccountSelected.emit(accountingCode);
  }

  delete(event: Event, accountingCode: AccountingAccountSummary): void {
    event.stopPropagation();
    this.onDelete.emit(accountingCode);
  }
}
